import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCuteRobot: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCuteRobot"><Path d="M10 10V7H8V10H10Z" fill="currentColor"/><Path d="M16 10V7H14V10H16Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M13 3V1H11V3H4V14H5V14.5858L2.58594 16.9999L4.00015 18.4141L5.31898 17.0953C6.20951 19.9377 8.86392 22 12 22C15.1362 22 17.7906 19.9376 18.6811 17.0951L20.0002 18.4141L21.4144 16.9999L19 14.5855V14H20V3H13ZM18 12V5H6V12H18Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCuteRobot;
